import React, { useEffect, useState } from 'react';
import { API_BASE, apiFetch } from './api';
import { DEFAULT_TEXTS, defaultDisplayLayout, normalizeDisplayLayout } from './displayLayoutModel';
import { theme } from './theme';
const GROUPS = { type: 'Standortarten', status: 'Status', label: 'Feldbezeichnungen', link: 'Prozess / Verknüpfung', time: 'Zeitangaben', system: 'Systemmeldungen', event: 'Ereignisse' };
export default function DisplayLayoutEditor() {
  const [resourceType, setResourceType] = useState('gate');
  const [layout, setLayout] = useState(() => defaultDisplayLayout());
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setBusy(true); setLoaded(false); setMessage('');
    apiFetch(API_BASE + '/display-layout?resourceType=' + resourceType, { signal: controller.signal })
      .then(async res => { if (!res.ok) throw new Error('Texte konnten nicht geladen werden.'); return res.json(); })
      .then(data => { if (!controller.signal.aborted) { setLayout(normalizeDisplayLayout(data.layout, resourceType)); setLoaded(true); } })
      .catch(error => { if (!controller.signal.aborted) setMessage(error.message); })
      .finally(() => { if (!controller.signal.aborted) setBusy(false); });
    return () => controller.abort();
  }, [resourceType]);
  async function save() {
    setBusy(true); setMessage('');
    try {
      const response = await apiFetch(API_BASE + '/display-layout', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ resourceType, layout }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Speichern fehlgeschlagen.');
      setLayout(normalizeDisplayLayout(data.layout, resourceType)); setMessage('Gespeichert. Laufende Displays übernehmen die Texte automatisch.');
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  }
  return <main style={{ padding: 24, maxWidth: 1200, margin: 'auto' }}>
    <h1>Texte / Bezeichnungen</h1>
    <p>Das TV-Layout ist fest definiert. Leere Eingaben verwenden den Standardtext. Platzhalter in geschweiften Klammern müssen erhalten bleiben.</p>
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
      <label>Displayart <select aria-label="Displayart" disabled={busy} value={resourceType} onChange={e => setResourceType(e.target.value)}><option value="gate">Tore</option><option value="loadingBay">Ladezonen</option></select></label>
      <button style={theme.button} disabled={busy || !loaded} onClick={save}>Speichern</button>
      <button style={theme.button} disabled={busy || !loaded} onClick={() => { setLayout(defaultDisplayLayout(resourceType)); setMessage('Standardtexte geladen. Zum Übernehmen speichern.'); }}>Standardtexte</button>
    </div>
    <p role="status">{busy ? 'Wird verarbeitet …' : message}</p>
    {loaded && Object.entries(GROUPS).map(([group, title]) => <fieldset key={group} disabled={busy} style={{ margin: '20px 0', border: '1px solid #8894a3', borderRadius: 6 }}>
      <legend>{title}</legend>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: 18, padding: 12 }}>
        {Object.entries(DEFAULT_TEXTS).filter(([key]) => key.split('.')[1] === group).map(([key, fallback]) => <label key={key} style={{ display: 'grid', gap: 6 }}>
          <span>{fallback}</span>
          <input aria-label={key} maxLength={500} value={layout.texts[key]} placeholder={fallback} onChange={e => setLayout(previous => ({ ...previous, texts: { ...previous.texts, [key]: e.target.value } }))} style={{ padding: 10, font: 'inherit', minWidth: 0 }} />
        </label>)}
      </div>
    </fieldset>)}
  </main>;
}
